import { Link2Icon as LinkIcon } from '@radix-ui/react-icons'
import { CSSProps } from 'style'

import { stringToSlug } from 'lib/utils/strings'

import Box from 'components/atomic/atoms/box'
import { IconStyled } from 'components/atomic/atoms/icon'
import Text from 'components/atomic/atoms/text'

import { FCC } from 'types/react'

type Props = {
  tag: 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
} & CSSProps

const SharedAnchorHeading: FCC<Props> = props => {
  const { tag, css, children, ...rest } = props

  if (typeof children !== 'string') {
    return null
  }

  return (
    <Box css={css}>
      <Box
        as="a"
        href={`#${stringToSlug(children.toString())}`}
        css={{
          display: 'inline-flex',
          alignItems: 'baseline',
          [`&:hover ${IconStyled}`]: {
            opacity: 1,
          },
        }}
      >
        <Text
          {...rest}
          id={stringToSlug(children.toString())}
          as={tag}
          data-heading
          css={{ scrollMarginTop: '$20' }}
        >
          {children}
        </Text>
        <IconStyled
          as={LinkIcon}
          color="text2"
          css={{ ml: '$2', opacity: 0, transition: '.2s ease-in' }}
          aria-hidden
        />
      </Box>
    </Box>
  )
}

export default SharedAnchorHeading
